import { Route, Routes, useParams } from 'react-router-dom'
import MainContainer from 'components/layout/MainContainer/MainContainer'
import FooterBar from 'components/UI/FooterBar'
import BookendsProvider from 'lib/BookendsProvider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import ClientEdit from '../../ClientEdit'
import { useEffect, useMemo, useState } from 'react'
import { useOrbit } from 'providers/OrbitProvider'
import ClientResource from 'resources/ClientResource'
import Suspenseful from 'components/Suspenseful'
import { AdCampaignSetTableLoaderWrapper } from 'components/pages/AdCampaignSetTable'


function nameOf(entity, _entityType) {
  if(entity?.attributes) {
    return entity.attributes?.name || '(No name)'
  } else {
    return '...'
  }
}

function fetchClient(store, id) {
  return store.cache.query(q => q.findRecord({type: "client", id: id})) || store.query(q => q.findRecord({type: "client", id: id}))
}

function AdminClientsPageMain({clientResource}) {
  // Load the client to the cache to ensure it's available
  clientResource.get()

  const { clientId } = useParams()
  const [client, setClient] = useState();
  const { store } = useOrbit()
  const clientName = nameOf(client, 'Client')

  useEffect(() => {
    Promise.resolve((clientId ? fetchClient(store, clientId) : null)).then(result => setClient(result))
  }, [store, clientId]);

  return (
    <BookendsProvider>
      <MainContainer>
        <Paper
          sx={{
            padding: '18px 24px',
            boxShadow: 0,
          }}
        >
          <Typography variant='h1'>
            {clientName}
          </Typography>

          <ClientEdit />
        </Paper>
      </MainContainer>

      <FooterBar/>
    </BookendsProvider>
  )
}

function AdminClientsPageLoader() {
  const { remote } = useOrbit()
  const { clientId } = useParams()
  const clientResource = useMemo(() => new ClientResource({ remote, id: clientId }), [remote, clientId])

  return (
    <Suspenseful
      component={AdminClientsPageMain}
      clientResource={clientResource}
      errorMessage="Error loading clients page"
    />
  )
}

export default function AdminClientsPage() {
  return (
    <Routes>
      <Route index element={<AdminClientsPageLoader/>}/>
      <Route path="ad-campaign-sets" element={<AdCampaignSetTableLoaderWrapper />} />
    </Routes>
  )
}
